export class CloneLocation {
  static readonly type = '[Contract.Location] Clone Location';
  constructor(public locID: number, public copies: number = 1, public locNum: string = null) {}
}

export class DeleteLocation {
  static readonly type = '[Contract.Location] Delete Location';
  constructor(public locID: number) {}
}

export class RestoreLocation {
  static readonly type = '[Contract.Location] Restore Location';
  constructor(public locID: number) {}
}

export class AddLocation {
  static readonly type = '[Contract.Location] Add Location';
  constructor(public location: any) {}
}

export class UpdateLocation {
  static readonly type = '[Contract.Location] Update Location';
  constructor(public location: any) {}
}

export class SetCurrentLocation {
  static readonly type = '[Contract.Location] Set Current Location';
  constructor(public location: any) {}
}

export class AddSubLocationLink {
  static readonly type = '[Contract.Location] Add Sub Location Link';
  constructor(public locID: number, public subLocID: number) {}
}

export class RemoveSubLocationLink {
  static readonly type = '[Contract.Location] Remove Sub Location Link';
  constructor(public locID: number, public subLocID: number, public subLocNum: string) {}
}

export class RemoveAllSubLocationLinks {
  static readonly type = '[Contract.Location] Remove All Sub Location Links';
  constructor(public locID: number) {}
}
